// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function hr(): string {
    return 'hr';
}
